import script from "./DesktopEnding.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopEnding.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopEnding.vue?vue&type=style&index=0&id=7d9062b3&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9062b3"]])

export default __exports__